<script lang="ts" setup>
  import { onMounted, ref,watch, reactive} from 'vue'; 
  import { setWindowSecurity,getWindowSecurity,IWindowSecurity,ModalWindowOpen, UpdateUserConfigurationScreens } from '../../lib/ChoiceUserConfiguration';
  import { popAlert} from "../../lib/Notification"
  import { AppScreens,PrivilegeType } from '../../Enums/ChoiceEnums'; 
  import { DateDisplayFormat,AlignmentType,TableRowType,ButtonDisplayStyle,DropDownButtonIconType } from '../../Enums/UiEnums'; 
  import { ToFilenameTimestamp,ToReportTimestamp,ToAccountingMoneyStr,ToPrettyNumber } from  "../../lib/StringFormat";
  import { ICol,iColDateSort, RenderModeType, IRowSelection, getSelectedTableItems , getSelectedTableCount, CellStyleDelegate} from "../../lib/ChoiceTableHelpers" ;
  import { textBaseClass, billingBaseClass, spinnerClassSmall, IActionButtonIdentifier, IActionButtons, ActionButtonStyle,ValidationState} from '../../lib/Types/Types';
  import { NoTzDate, getNoTzToday, getNoTzDateAdd,toDisplayDateString} from "../../lib/DateUtils";
  import { currentChoiceUser} from "../../lib/ChoiceUtils";
  import ActionFoldingPanel from "../../components/ActionFoldingPanel.vue"; 
  import DatePickerNoTZ from '../../components/DatePickerNoTZ.vue';
  import IntegerInput from '../../components/IntegerInput.vue';
  import TextInput from '../../components/TextInput.vue';
  import CurrencyInput from '../../components/CurrencyInput.vue';
  import ActionButton from "../../components/ActionButton.vue"; 
  import ChoiceTable from "../../components/ChoiceTable.vue";
  import ModalDialog from "../../components/ModalDialog.vue";
  import DropDownButton from "../../components/DropDownButton.vue";
  import DropDownButtonItem from "../../components/DropDownButtonItem.vue";
  import {NumberToLocaleString,prettyCurrency} from '../../lib/Formatting/Number' 
  import * as Export from '../../lib/Export';
  import Validator from '../../components/Validator.vue';  
  import { 
    paymentbatch, paymentbatchid, paymentbatchdetails, paymentbatchidsearch,
    PaymentBatchStatus, PaymentBatchUpdateType, PaymentBatchIdType,PaymentBatchUpdateIdType, 
    IPaymentBatchValues,IPaymentBatchDeposits,IPaymentBatchReceipts, IPaymentBatchDetailsResponse, 
    IPaymentBatchUpdateInputs, IPaymentBatchUpdateIDInputs,IPaymentBatchUpdateIDs,
    IDepositReceiptsSearch, IDepositsSearch, IReceiptsSearch,IPaymentBatchReport} from '../../lib/Models/BillingModel';  

  const actionButtonWidth = 120;
  const modalButtonWidth = 120;
 
  enum PageActions{
    Audit,
    Refresh 
  } 
  enum DetailButtonId {
    Complete = 0,
    ReOpen = 1,
    Reassign = 2,
    Remove = 3,
    Report = 4,
    Setting = 99
  }
  enum DepositButtonId {
    New = 0,
    Add = 1,
    Remove = 2,
    Setting = 99
  }
  enum ReceiptButtonId {
    Add = 0,
    Remove = 1,
    Setting = 99
  }
  enum ModalRequests { 
    None = 0,
    CompleteBatch = 1,
    RemoveDeposit = 2,
    RemoveReceipt = 3,
    NoRemoveDeposit = 4,
    NoRemoveReceipt = 5,
    TableUpdateResponse = 6,
    AddDeposit = 7,
    AddReceipt = 8,
    NewDeposit = 9,
    NewReceipt = 10
  } 
  
  const validateSection = ref();  

  interface IModalInformation {
    title: string,
    message?: string,
    completeText?: string,
    completeTootlTip?: string, 
    closeToolTip?: string
  } 
  const modalInput = ref<IModalInformation[]>([
    {title: "Blank"},
    {title: "Complete Payment Batch", message: "", completeText: "Complete", completeTootlTip: "Complete payment batch", closeToolTip: "Do not complete payment batch"},
    {title: "Remove Deposit(s)", message: "Are you sure you wish to remove the following deposits?", completeText: "Remove", completeTootlTip: "Remove deposits", closeToolTip: "Do not remove any deposits"},
    {title: "Remove Receipt(s)", message: "Are you sure you wish to remove the following receipts?", completeText: "Remove", completeTootlTip: "Remove receipts", closeToolTip: "Do not remove any receipts"},
    {title: "Remove Deposit(s)", message: "No Deposits have been selected.", completeText: "", completeTootlTip: "", closeToolTip: "Close"},
    {title: "Remove Receipt(s)", message: "No Receipts have been selected.", completeText: "", completeTootlTip: "", closeToolTip: "Close"},
    {title: "Table update", completeText: "OK", completeTootlTip: "Refresh Listing", closeToolTip: ""},
    {title: "Add Deposit(s)", message: "Enter the date range of the deposits you are searching for.<br/><i>Note: Only the first 50 records will be returned.</i><br/><br/>", completeText: "Add", completeTootlTip: "Add deposits", closeToolTip: "Do not add any deposits"},
    {title: "Add Receipts(s)", message: "Enter the date range of the receipts you are searching for.<br/><i>Note: Only the first 50 records will be returned.</i><br/><br/>", completeText: "Add", completeTootlTip: "Add receipts", closeToolTip: "Do not add any receipts"}
  ]);
  const windowSecurity = ref<IWindowSecurity[]>([
    {screenId: AppScreens.PaymentBatchDetail,security: PrivilegeType.None},
    {screenId: AppScreens.CloseAllPaymentBatch,security: PrivilegeType.None},
    {screenId: AppScreens.CloseUserPaymentBatch,security: PrivilegeType.None},
    {screenId: AppScreens.ReOpenPaymentBatch,security: PrivilegeType.None },
    {screenId: AppScreens.ReAssignPaymentBatch ,security: PrivilegeType.None},
    {screenId: AppScreens.UpdatePaymentBatch,security: PrivilegeType.None},
    {screenId: AppScreens.DocumentScan,security: PrivilegeType.None},
    {screenId: AppScreens.DepositNew,security: PrivilegeType.None} ,
    {screenId: AppScreens.Deposit,security: PrivilegeType.None} ,
    {screenId: AppScreens.ReceiptDetails,security: PrivilegeType.None}
  ]);
  
  const formData = reactive <
    {  
      currentUser: string,
      setting: {iconClass: DropDownButtonIconType, loading: boolean}, 
      resultsError: {flag: boolean, message: string}, 
      resultsWarning: {flag: boolean, message: string}, 
      panels: {details: boolean, deposits: boolean, receipts: boolean},   
      inputs: {payment_batch_date?: NoTzDate, total_input_value?: number, item_input_value?: number, notes?: string},    
      attachment: {text: string, executing: boolean, disabled: boolean},
      modal: {id: number, error_message?: string, executing?: boolean, closing?: boolean, display: boolean, display_connect_table: boolean},
      searchDates: {display: boolean, executing: boolean, start_date: NoTzDate, end_date: NoTzDate}, 
      respDetails?: IPaymentBatchDetailsResponse,
      detailsData?: IPaymentBatchValues, 
      reportingFooter: Record<string,any>,
      reporting: {display: boolean, executing: boolean, printing: boolean, exporting: boolean}, 
      inputsAreValid: boolean
    }>(
    {  
      currentUser: currentChoiceUser() ?? "",
      setting: {iconClass: DropDownButtonIconType.Gear, loading: true},  
      resultsError: {flag: false, message: ""}, 
      resultsWarning: {flag: false, message: ""}, 
      panels: {details: true, deposits: true, receipts: true},  
      inputs: {payment_batch_date: "", total_input_value: 0, item_input_value: 0, notes: ""},      
      attachment: {text: "", executing: false, disabled: true}, 
      modal: {id: ModalRequests.None, error_message: "", executing: false, closing: false, display: false, display_connect_table: false},
      searchDates: {display: false, executing: false, start_date: getNoTzDateAdd(-10,DateDisplayFormat.NumericDashDate), end_date: getNoTzToday(DateDisplayFormat.NumericDashDate)},
      reportingFooter: {checkNumber: "", postAmount: 0, appliedAmount: 0, unappliedAmount: 0},
      reporting: {display: false, executing: false, printing: false, exporting: false}, 
      inputsAreValid: true
    }); 
  
  const DetailButtons = ref<IActionButtons>(
    [
      {baseText: 'Complete', disabled: true, clickEvent: checkCompleteBatch, toolTip: 'Complete Payment Batch', width: actionButtonWidth, spinText: "Completing", overRideStyle:ActionButtonStyle.Lock},
      {baseText: 'Re-open', disabled: true, clickEvent: reopenBatch, toolTip: 'Re-open Payment Batch', width: actionButtonWidth, spinText: "Re-opening", overRideStyle:ActionButtonStyle.Unlock},
      {disabled: true, clickEvent: reassignBatch, toolTip: 'Re-assign Payment Batch', width: actionButtonWidth, overRideStyle:ActionButtonStyle.Reassign},
      {disabled: true, clickEvent: removeBatch, toolTip: 'Remove Payment Batch', width: actionButtonWidth, overRideStyle:ActionButtonStyle.Remove},
      {disabled: true, clickEvent: reportBatch, toolTip: 'Report Payment Batch', width: actionButtonWidth, overRideStyle:ActionButtonStyle.Report}
    ] 
  ); 

  const checkStatus: CellStyleDelegate = (_col: ICol, row: Record<string, any>, rowType: TableRowType): Record<string, string> | undefined => {
    if (rowType === TableRowType.Body)
    { 
        if (row["recordStatus"]  !== 0 ) {
          const styles: Record<string, string> = {};
          styles["color"] = "red";
          return styles;
        }  
    }
  }    
  const connectData = ref<(IPaymentBatchUpdateIDs |IPaymentBatchDeposits | IPaymentBatchReceipts | (IDepositsSearch & IRowSelection) | (IReceiptsSearch & IRowSelection))[]>([]);
  const connectTable = ref<InstanceType<typeof ChoiceTable>>();      
  const connectColumns = ref<ICol[]>([]);
  const connectUpdateColumns = ref<ICol[]>([
    { Name: 'ID', DataField: 'tableID', StyleDel: checkStatus},
    { Name: 'Message', DataField: 'recordMessage', StyleDel: checkStatus}
  ]);
  const connectDepositColumns = ref<ICol[]>([
    { Name: 'ID', DataField: 'depositID'},
    { Name: 'Date', DataField: 'depositDate', Alignment: AlignmentType.Center},
    { Name: 'Sys ID', DataField: 'payerEid'},
    { Name: 'Payer Name', DataField: 'payerName'}
  ]);
  const connectReceiptColumns = ref<ICol[]>([
    { Name: 'ID', DataField: 'receiptID'},
    { Name: 'Date', DataField: 'receiptDate', Alignment: AlignmentType.Center},
    { Name: 'Chart', DataField: 'patientID'},
    { Name: 'Patient Name', DataField: 'patientName'}
  ]); 
  const connectSearchDepositColumns = ref<ICol[]>([
    { Name: '', DataField:"selected", RenderMode: RenderModeType.Selection },
    { Name: 'ID', DataField: 'depositID'},
    { Name: 'Date', DataField: 'depositDate', Alignment: AlignmentType.Center},
    { Name: 'Sys ID', DataField: 'payerEid'},
    { Name: 'Payer Name', DataField: 'payerName'},
    { Name: 'Amount', DataField: 'depositAmount', Alignment: AlignmentType.Right, RenderMode: RenderModeType.AccountingMoney}
  ]); 
  const connectSearchReceiptColumns = ref<ICol[]>([
    { Name: '', DataField:"selected", RenderMode: RenderModeType.Selection },
    { Name: 'ID', DataField: 'receiptID'},
    { Name: 'Date', DataField: 'receiptDate', Alignment: AlignmentType.Center},
    { Name: 'Chart', DataField: 'patientId'},
    { Name: 'Patient Name', DataField: 'patientName'},
    { Name: 'Amount', DataField: 'paidAmount', Alignment: AlignmentType.Right, RenderMode: RenderModeType.AccountingMoney}
  ]);
  const depositsData = ref<(IPaymentBatchDeposits & IRowSelection)[]>([]);
  const depositTable = ref<InstanceType<typeof ChoiceTable>>();      
  const depositColumns = ref<ICol[]>([
    { Name: '', DataField:"selected", RenderMode: RenderModeType.Selection },
    { Name: 'ID', DataField: 'depositID' },
    { Name: 'Payer Name', DataField: 'payerName' },
    { Name: 'Sys ID', DataField: 'payerEid' },
    { Name: 'Payment Method', DataField: 'paymentMethodDescription' },
    { Name: 'Check/Trace Number', DataField: 'checkNumber' },
    { Name: 'Amount', DataField: 'depositAmount', Alignment: AlignmentType.Right, RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Applied', DataField: 'depositApplied',  Alignment: AlignmentType.Right, RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Unapplied', DataField: 'depositUnapplied', Alignment: AlignmentType.Right, RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Date', DataField: 'depositDate', Alignment: AlignmentType.Center, Sort: (row) => iColDateSort(row?.depositDate,DateDisplayFormat.NumericDate) },
  ]);
  const DepositButtons = ref<IActionButtons>(
    [
      {baseText: 'New', disabled: true, clickEvent: newDeposit, toolTip: 'Create New Deposit', width: actionButtonWidth, overRideStyle:ActionButtonStyle.New},
      {disabled: true, clickEvent: searchAddDeposits, toolTip: 'Add Deposit', width: actionButtonWidth, overRideStyle:ActionButtonStyle.Add},
      {disabled: true, clickEvent: checkRemoveDeposit, toolTip: 'Remove Deposit', width: actionButtonWidth, overRideStyle:ActionButtonStyle.Remove}
    ]
  );  
  const receiptsData = ref<(IPaymentBatchReceipts & IRowSelection)[]>([]);
  const receiptTable = ref<InstanceType<typeof ChoiceTable>>();
  const receiptColumns = ref<ICol[]>([
    { Name: '', DataField:"selected", RenderMode: RenderModeType.Selection },
    { Name: 'ID', DataField: 'receiptID' },
    { Name: 'Patient Name', DataField: 'patientName' },
    { Name: 'Chart', DataField: 'patientId' },
    { Name: 'Payment Method', DataField: 'paymentMethodDescription' },
    { Name: 'Check/Trace Number', DataField: 'checkNumber' },
    { Name: 'Amount', DataField: 'paidAmount',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Applied', DataField: 'appliedAmount',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Unapplied', DataField: 'unappliedAmount',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Date', DataField: 'receiptDate',Alignment: AlignmentType.Center, Sort: (row) => iColDateSort(row?.receiptDate,DateDisplayFormat.NumericDate)},
  ]); 
  const reportData = ref<(IPaymentBatchReport)[]>([]);
  const reportTable = ref<InstanceType<typeof ChoiceTable>>();
  const reportColumns = ref<ICol[]>([
    { Name: 'Date', DataField: 'Date',Alignment: AlignmentType.Center, Sort: (row) => iColDateSort(row?.Date,DateDisplayFormat.NumericDate)},
    { Name: 'ID', DataField: 'ID' },
    { Name: 'Payer', DataField: 'payerName' },
    { Name: 'Payment Method', DataField: 'paymentMethod' },
    { Name: 'Payment Type', DataField: 'paymentType' },
    { Name: 'Check/Trace Number', DataField: 'checkNumber' },
    { Name: 'Amount', DataField: 'postAmount',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Applied', DataField: 'appliedAmount',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney },
    { Name: 'Unapplied', DataField: 'unappliedAmount',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney }, 
  ]);
  let secondaryModal: boolean;
  let secondaryModalIdInput : IPaymentBatchUpdateIDInputs; 
  
  const ReceiptButtons = ref<IActionButtons>(
    [
      {disabled: true, clickEvent: searchAddReceipts, toolTip: 'Add Receipt', width: actionButtonWidth, overRideStyle:ActionButtonStyle.Add},
      {disabled: true, clickEvent: checkRemoveReceipt, toolTip: 'Remove Receipt', width: actionButtonWidth, overRideStyle:ActionButtonStyle.Remove}
    ]
    /*
    For now this button will be "held back"
    {baseText: 'New', disabled: true, clickEvent: newReceipt, toolTip: 'Create New Receipt', width: actionButtonWidth, overRideStyle:ActionButtonStyle.New},
    */
  );  
  const props = withDefaults(defineProps<{
    paymentBatchId: number,
    paymentRefresh: number,
    paymentImageData: string
  }>(), 
  { 
    paymentBatchId: -1,
    paymentRefresh: -1,
    paymentImageData: ""
  });

  onMounted(async () => {  
    await setWindowSecurity(windowSecurity.value); 
    formData.attachment.disabled = (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail)  < PrivilegeType.ReadUpdate ? true : false); 
    refreshData(); 
  });

  watch(() => props.paymentImageData, (newImageData,oldImageData) => { 
    if ((newImageData != "") && (newImageData !== oldImageData)) { 
      ChangeAttachment(newImageData.toString());   
    }
  });
  watch(() => props.paymentBatchId, (newID, oldID) => {
    if (newID !== oldID)  {
      refreshData(); 
    }
  });
  watch(() => props.paymentRefresh, (newRefresh,oldRefresh) => { 
    if (newRefresh !== oldRefresh) {
      refreshData(); 
    }
  });

  const emit = defineEmits<{
        (e: "openwindows", strValue: string): void
      }>();

  async function refreshData()  : Promise<void> {    
    formData.reporting.display = false;
    formData.setting.iconClass = DropDownButtonIconType.Spinner;
    formData.setting.loading = true; 
    resetModalConnect(false);
    resetErrorMessage();
    formData.respDetails = await paymentbatchdetails.PaymentBatchDetails(props.paymentBatchId) as IPaymentBatchDetailsResponse;
    const default_err_message = "Missing or Invalid Payment Batch detail information.";

    if (!formData.respDetails.isSuccess) { 
      formData.resultsError = {flag: true, message: formData.respDetails.message ?? default_err_message};
      popAlert(formData.resultsError.message,"Payment Batch Details");
      return;
    }
    if (!formData.respDetails.paymentBatchValueList) {  
      formData.resultsError = {flag: true, message: default_err_message};
      popAlert(formData.resultsError.message,"Payment Batch Details");
      return;
    }
    formData.detailsData = formData.respDetails.paymentBatchValueList[0]; 
    depositsData.value = formData.respDetails.paymentBatchDepositList ?? [];
    receiptsData.value = formData.respDetails.paymentBatchReceiptList ?? []; 
    reportData.value = depositsData.value.map(item => ({ID: "D-" + item.depositID, Date: item.depositDate, payerName: item.payerName, paymentMethod: item.paymentMethodDescription, paymentType: item.paymentTypeDescription, checkNumber: item.checkNumber, postAmount: item.depositAmount, appliedAmount: item.depositApplied, unappliedAmount: item.depositUnapplied}))
    reportData.value.push(...receiptsData.value.map(item => ({ID: "R-" + item.receiptID, Date: item.receiptDate, payerName: item.patientName, paymentMethod: item.paymentMethodDescription, paymentType: item.paymentTypeDescription, checkNumber: item.checkNumber, postAmount: item.paidAmount, appliedAmount: item.appliedAmount, unappliedAmount: item.unappliedAmount})))
    formData.inputs.total_input_value = formData.detailsData?.totalAmount ?? 0; 
    formData.inputs.item_input_value = formData.detailsData?.itemCount ?? 0;  
    formData.inputs.payment_batch_date = formData.detailsData?.paymentBatchDate ?? getNoTzToday(DateDisplayFormat.NumericDashDate);
    ValidateFutureDate(false);
    formData.inputs.notes = formData.detailsData?.description ?? "";
    formData.attachment.text = formData.detailsData?.paymentBatchFileName ?? "Attach eDocument"; 
    formData.modal.display = false;
    CheckButtonStatus();
    formData.setting.loading = false; 
    formData.setting.iconClass = DropDownButtonIconType.Gear;
    formData.reportingFooter = 
      {
        checkNumber: "Totals:",
        postAmount: formData.detailsData.totalPosted,
        appliedAmount: formData.detailsData.totalApplied,
        unappliedAmount: formData.detailsData.totalUnapplied    
      } 
  }
  
  function CheckButtonStatus() : void  {
    // Detail Buttons
    EnableCompletButton();
    EnableReopenButton();
    EnableReassignButton();
    EnableRemoveButton();
    EnableReportButton();
    EnableAttachButton();
    // Deposit Buttons
    EnableDepositNewButton();
    EnableDepositAddButton();
    EnableDepositRemoveButton();
    // Receipt Buttons
    //EnableReceiptNewButton(); on hold
    EnableReceiptAddButton();
    EnableReceiptRemoveButton();
  }
  // Modal Functions  
  async function executeSearch() : Promise<void> {
    formData.searchDates.executing = true;
    formData.modal.error_message = "";

    const payment_batch_type_id = (formData.modal.id === ModalRequests.AddDeposit ? PaymentBatchIdType.Deposit : PaymentBatchIdType.Receipt);
    const respSearch = await paymentbatchidsearch.PaymentBatchIDSearch(payment_batch_type_id, formData.searchDates.start_date, formData.searchDates.end_date) as IDepositReceiptsSearch;
    
    if (formData.modal.id === ModalRequests.AddDeposit) {
      connectData.value = respSearch.depositsList ?? [];
      connectColumns.value = connectSearchDepositColumns.value;
    }
    else if (formData.modal.id === ModalRequests.AddReceipt) {
      connectData.value = respSearch.receiptsList ?? [];
      connectColumns.value = connectSearchReceiptColumns.value;
    } 
    formData.searchDates.executing = false;
    formData.modal.display_connect_table = true;  
  }
  function resetModalDateSearch() : void { 
    formData.searchDates.display = false;
    formData.searchDates.start_date = getNoTzDateAdd(-10,DateDisplayFormat.NumericDashDate);
    formData.searchDates.end_date = getNoTzToday(DateDisplayFormat.NumericDashDate);
  }
  function resetModalConnect(connect_table_only : boolean) : void {
    if (!connect_table_only) {
      resetModalDateSearch();
      formData.modal.display = false;
      formData.modal.id = ModalRequests.None;
    }
    connectData.value = []; 
    formData.modal.display_connect_table = false;
    formData.modal.error_message = "";
    formData.modal.executing = false; 
    formData.modal.closing = false; 
  }
  function executeModal(input : IActionButtonIdentifier | undefined) : void  { 
    formData.modal.executing = true;
    
    setTimeout(() => { 
      formData.modal.executing = false;
      let current_id = formData.modal.id;
      switch (current_id) {
        case ModalRequests.CompleteBatch:
          resetModalConnect(false);
          completeBatch();
          break;
        case ModalRequests.RemoveDeposit: 
          resetModalConnect(false);
          removeDeposit();
          break;
        case ModalRequests.RemoveReceipt:
          resetModalConnect(false);
          removeReceipt ();
          break; 
        case ModalRequests.TableUpdateResponse:
          resetModalConnect(false);
          modalInput.value[ModalRequests.TableUpdateResponse].title = "";
          modalInput.value[ModalRequests.TableUpdateResponse].message = "";
          refreshData();
          break;
        case ModalRequests.AddDeposit:
          addDeposits(); 
          break;
        case ModalRequests.AddReceipt:
          addReceipts();
          break;
      }
    },150); 
  }
  function cancelModal(_input : IActionButtonIdentifier | undefined)  : void { 
    formData.modal.closing = true;
    setTimeout(() => { 
      resetModalConnect(false);
    },150); 
  }
  // Detail Functions
  function onUpdateDetails(isPanelOpen : boolean) : void  {
    formData.panels.details = isPanelOpen;
    EnableRemoveButton();
  }
  // Completion Functions
  function EnableCompletButton() : void  {
    if ((formData.detailsData?.status === PaymentBatchStatus.Completed) ||
        (formData.detailsData?.status === PaymentBatchStatus.Removed)) {
      DetailButtons.value[DetailButtonId.Complete].disabled = true;
      return;
    }
    if ((depositsData?.value.length === 0) && (receiptsData.value?.length === 0)) {
      DetailButtons.value[DetailButtonId.Complete].disabled = true;
      return;
    }
    if ((formData.currentUser === formData.detailsData?.assignedUserId) && (getWindowSecurity(windowSecurity.value,AppScreens.CloseUserPaymentBatch) > PrivilegeType.Read)) {
      DetailButtons.value[DetailButtonId.Complete].disabled = false;
      return;
    }
    if (getWindowSecurity(windowSecurity.value,AppScreens.CloseAllPaymentBatch) > PrivilegeType.Read) {
      DetailButtons.value[DetailButtonId.Complete].disabled = false;
      return;
    }
    DetailButtons.value[DetailButtonId.Complete].disabled = true;
  }
  function checkCompleteBatch()  : void {
    let itemMessage = "";
    let totalMessage = "";
    resetModalConnect(false);
    DetailButtons.value[DetailButtonId.Complete].executing = true; 
    formData.modal.id = ModalRequests.CompleteBatch;  

    const compare_total_amount = (formData.detailsData?.totalAmount ?? 0);
    const compare_total_posted = (formData.detailsData?.totalPosted ?? 0);
    const compare_item_count = (formData.detailsData?.itemCount ?? 0);
    const compare_items_posted = (formData.detailsData?.itemsPosted ?? 0);

    // Detemine a message requirements
    
    if (compare_total_posted != compare_total_amount) {
      totalMessage = `<br/><div class="alert alert-danger">*The entered dollar amount of ${prettyCurrency(compare_total_amount)} for your batch does not match the Total Posted amount of ${prettyCurrency(compare_total_posted)} for your batch.</div>`
    } 

    if (compare_items_posted != compare_item_count) {
      itemMessage = `<br/><div class="alert alert-danger">*The entered number of Items of ${NumberToLocaleString(compare_item_count)} for your batch does not match the Posted Items of ${NumberToLocaleString(compare_items_posted)} for your batch.</div>`
    }
    modalInput.value[ModalRequests.CompleteBatch].message = 
      `Set this Payment Batch to complete?<br/>Once completed, <strong>only</strong> users with certain permissions will be able to re-open this batch.<br/>${totalMessage}${itemMessage}`;
  
    setTimeout(() => {  
      DetailButtons.value[DetailButtonId.Complete].executing = false; 
      formData.modal.display = true;
    },150);
  }
  function completeBatch() {  
    DetailButtons.value[DetailButtonId.Complete].executing = true;  
    const paymentBatchInputs: IPaymentBatchUpdateInputs = {update_command: PaymentBatchUpdateType.Complete, payment_batch_id:props.paymentBatchId}; 
    UpdateDetails(paymentBatchInputs,DetailButtonId.Complete); 
  }
  // Reopen Functions
  function EnableReopenButton() : void {
    if (formData.detailsData?.status === PaymentBatchStatus.New) {
      DetailButtons.value[DetailButtonId.ReOpen].disabled = true;
      return;
    }
    if (getWindowSecurity(windowSecurity.value,AppScreens.ReOpenPaymentBatch) > PrivilegeType.Read) {
      DetailButtons.value[DetailButtonId.ReOpen].disabled = false;
      return;
    }
    DetailButtons.value[DetailButtonId.ReOpen].disabled = true;
  } 
  function reopenBatch(_input : IActionButtonIdentifier | undefined) {
    DetailButtons.value[DetailButtonId.ReOpen].executing = true;  
    const paymentBatchInputs: IPaymentBatchUpdateInputs = {update_command: PaymentBatchUpdateType.Reopen, payment_batch_id:props.paymentBatchId}; 
    UpdateDetails(paymentBatchInputs,DetailButtonId.ReOpen);
  }
  // Reassign Functions
  function EnableReassignButton() : void  {
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      DetailButtons.value[DetailButtonId.Reassign].disabled = true;
      return;
    }    
    if ((formData.currentUser !== formData.detailsData?.assignedUserId) && (getWindowSecurity(windowSecurity.value,AppScreens.ReAssignPaymentBatch) > PrivilegeType.Read)) {
      DetailButtons.value[DetailButtonId.Reassign].disabled = false;
      return;
    }
    DetailButtons.value[DetailButtonId.Reassign].disabled = true;    
  }
  function reassignBatch(_input : IActionButtonIdentifier | undefined) : void  {
    DetailButtons.value[DetailButtonId.Reassign].executing = true; 
    const paymentBatchInputs: IPaymentBatchUpdateInputs = {update_command: PaymentBatchUpdateType.Reassign, payment_batch_id:props.paymentBatchId}; 
    UpdateDetails(paymentBatchInputs,DetailButtonId.Reassign);
  } 
  // Remove Functions
  function EnableRemoveButton() : void  {
    if (!formData.panels.details) {
      DetailButtons.value[DetailButtonId.Remove].disabled = true;
      return;
    }  
    if ((formData.detailsData?.status === PaymentBatchStatus.Completed) ||
        (formData.detailsData?.status === PaymentBatchStatus.Removed)) {
      DetailButtons.value[DetailButtonId.Remove].disabled = true;
      return;
    }  
    if (((depositsData.value??[]).length > 0) || ((receiptsData.value??[]).length > 0)) {
      DetailButtons.value[DetailButtonId.Remove].disabled = true;
      return;
    }  
    if (getWindowSecurity(windowSecurity.value,AppScreens.UpdatePaymentBatch) > PrivilegeType.Read) {
      DetailButtons.value[DetailButtonId.Remove].disabled = false;
      return;
    }    
    if ((formData.currentUser === formData.detailsData?.assignedUserId) && (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.Read)) {
      DetailButtons.value[DetailButtonId.Remove].disabled = false;
      return;
    }          
    DetailButtons.value[DetailButtonId.Remove].disabled = true;    
  }
  function removeBatch(input : IActionButtonIdentifier | undefined) {
    DetailButtons.value[DetailButtonId.Remove].executing = true;  
    const paymentBatchInputs: IPaymentBatchUpdateInputs = {update_command: PaymentBatchUpdateType.Remove, payment_batch_id: props.paymentBatchId}; 
    UpdateDetails(paymentBatchInputs,DetailButtonId.Remove);
  }
  // Report Functions
  function EnableReportButton() : void  {      
    if (reportData.value.length === 0) {
      DetailButtons.value[DetailButtonId.Report].disabled = true;
      return; 
    }
    if (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.None) {
      DetailButtons.value[DetailButtonId.Report].disabled = false;
      return;
    }  
    DetailButtons.value[DetailButtonId.Report].disabled = true;    
  }
  function reportBatch(_input : IActionButtonIdentifier | undefined) : void  {
    DetailButtons.value[DetailButtonId.Report].executing = true;
    setTimeout(() => {
      formData.reporting.display = true;
      DetailButtons.value[DetailButtonId.Report].executing = false;
    },150);
  }
  function reportDetails(_input : IActionButtonIdentifier | undefined) : void  { 
    formData.reporting.executing = true;
    setTimeout(() => {
      formData.reporting.display = false;
      formData.reporting.executing = false;
    },150);
  }
  function reportPrint(_input : IActionButtonIdentifier | undefined) : void  { 
    formData.reporting.printing = true;
    window.print();    
    setTimeout(() => {
      formData.reporting.printing = false;
    },150);
  }
  function reportExport(_input : IActionButtonIdentifier | undefined) : void  {
    formData.reporting.exporting = true;
    const columnHeaderNames = 
      reportColumns.value.filter(col => col.DataField)
      .map(col => [{v: col.Name, t: Export.ExcelDataType.String, s: {fill: {fgColor: Export.ExcelStyles.HeaderColor},font: Export.ExcelStyles.FontBold, alignment: Export.ExcelStyles.AlignmentCenter,border: Export.ExcelStyles.ThinBorder}}])
      .flat();
    const reporting_data = 
      reportData.value.map(item => 
        [
          {v: item.Date, t: Export.ExcelDataType.Date, s: {border: Export.ExcelStyles.ThinBorder}},
          {v: item.ID, t: Export.ExcelDataType.String, s: {border: Export.ExcelStyles.ThinBorder}},
          {v: item.payerName, t: Export.ExcelDataType.String, s: {border: Export.ExcelStyles.ThinBorder}},
          {v: item.paymentMethod, t: Export.ExcelDataType.String, s: {border: Export.ExcelStyles.ThinBorder}},
          {v: item.paymentType, t: Export.ExcelDataType.String, s: {border: Export.ExcelStyles.ThinBorder}},
          {v: item.checkNumber, t: Export.ExcelDataType.String, s: {border: Export.ExcelStyles.ThinBorder}},
          {v: item.postAmount, t: Export.ExcelDataType.Number, s: {numFmt: Export.ExcelFormats.CurrencyFormatRed, border: Export.ExcelStyles.ThinBorder}}, 
          {v: item.appliedAmount, t: Export.ExcelDataType.Number, s: {numFmt: Export.ExcelFormats.CurrencyFormatRed, border: Export.ExcelStyles.ThinBorder}}, 
          {v: item.unappliedAmount, t: Export.ExcelDataType.Number, s: {numFmt: Export.ExcelFormats.CurrencyFormatRed, border: Export.ExcelStyles.ThinBorder}}, 
        ]); 
    const reporting_header = 
      [
        {v: "Details:", t: Export.ExcelDataType.String, s: {font: Export.ExcelStyles.FontBold, alignment: Export.ExcelStyles.AlignmentCenter}},
        {v: "Batch #:", t: Export.ExcelDataType.String, s: {font: Export.ExcelStyles.FontBold, alignment: Export.ExcelStyles.AlignmentRight}},
        {v: (formData.detailsData?.paymentBatchId ?? ""), t: Export.ExcelDataType.Number, s: {alignment: Export.ExcelStyles.AlignmentLeft}},
        {v: "Batch Date:", t: Export.ExcelDataType.String, s: {font: Export.ExcelStyles.FontBold, alignment: Export.ExcelStyles.AlignmentRight}},
        {v: (formData.detailsData?.paymentBatchDate ?? ""), t: Export.ExcelDataType.Date, s: {alignment: Export.ExcelStyles.AlignmentLeft}},
        {v: "Item Count:", t: Export.ExcelDataType.String, s: {font: Export.ExcelStyles.FontBold, alignment: Export.ExcelStyles.AlignmentRight}},
        {v: (formData.detailsData?.itemCount ?? 0), t: Export.ExcelDataType.Number, s: {alignment: Export.ExcelStyles.AlignmentLeft}},
        {v: "Batch Amount:", t: Export.ExcelDataType.String, s: {font: Export.ExcelStyles.FontBold, alignment: Export.ExcelStyles.AlignmentRight}},
        {v: (formData.detailsData?.totalAmount ?? 0), t: Export.ExcelDataType.Number, s: {alignment: Export.ExcelStyles.AlignmentLeft, numFmt: Export.ExcelFormats.CurrencyFormatRed}}, 
      ];
    const reporting_total = 
      [
        "","","","","",
        {v: "Totals:", t: Export.ExcelDataType.String,s: {fill: {fgColor: Export.ExcelStyles.HeaderColor},font: Export.ExcelStyles.FontBold, alignment: Export.ExcelStyles.AlignmentRight,border: Export.ExcelStyles.ThinBorder}},
        {v: (formData.detailsData?.totalPosted ?? 0), t: Export.ExcelDataType.Number, s: {fill: {fgColor: Export.ExcelStyles.HeaderColor},font: Export.ExcelStyles.FontBold, numFmt: Export.ExcelFormats.CurrencyFormatRed,border: Export.ExcelStyles.ThinBorder}}, 
        {v: (formData.detailsData?.totalApplied ?? 0), t: Export.ExcelDataType.Number, s: {fill: {fgColor: Export.ExcelStyles.HeaderColor},font: Export.ExcelStyles.FontBold, numFmt: Export.ExcelFormats.CurrencyFormatRed,border: Export.ExcelStyles.ThinBorder}},
        {v: (formData.detailsData?.totalUnapplied ?? 0), t: Export.ExcelDataType.Number, s: {fill: {fgColor: Export.ExcelStyles.HeaderColor},font: Export.ExcelStyles.FontBold, numFmt: Export.ExcelFormats.CurrencyFormatRed,border: Export.ExcelStyles.ThinBorder}}, 
      ];
    const mergeColWidths =  
    [
      Export.ExcelColWidths.Date,
      Export.ExcelColWidths.ID,
      Export.ExcelColWidths.Name,
      Export.ExcelColWidths.PaymentType,
      Export.ExcelColWidths.PaymentType,
      Export.ExcelColWidths.CheckNumber,
      Export.ExcelColWidths.Currency,
      Export.ExcelColWidths.Currency,
      Export.ExcelColWidths.Currency,
    ];
    
    let exportData = [];
      // Header Rows
      exportData.push([{v: "Payment Batch Report", t: Export.ExcelDataType.String, s: Export.ExcelStyles.MainHeader}]);
      exportData.push([{v: ToReportTimestamp(), t: Export.ExcelDataType.String, s: Export.ExcelStyles.DateHeader}]);
      exportData.push([]); // Blank Row
      exportData.push(reporting_header); 
      exportData.push([]); // Blank Row

      // Export the table header
      exportData.push(columnHeaderNames); 
      // Export the table data
      for(const row of reporting_data)
        exportData.push(row);
      // table footer
      exportData.push(reporting_total); 

    const mergeHeaderCells = 
    [
        Export.CellRange(new Export.CellModel(0, 0), new Export.CellModel(0, columnHeaderNames.length - 1)),
        Export.CellRange(new Export.CellModel(1, 0), new Export.CellModel(1, columnHeaderNames.length - 1)),
        Export.CellRange(new Export.CellModel(2, 0), new Export.CellModel(2, columnHeaderNames.length - 1)),
        Export.CellRange(new Export.CellModel(4, 0), new Export.CellModel(4, columnHeaderNames.length - 1))
    ];
    Export.ExportSheetToExcel(exportData, `PaymentBatch_${ToFilenameTimestamp()}.xlsx`, "Payment Batch",  { merge: mergeHeaderCells, cols:  mergeColWidths});
    setTimeout(() => {
      formData.reporting.exporting = false;
    },150); 
  }
  // eDocument Functions
  function EnableAttachButton() : void  {
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      formData.attachment.disabled = true;
      return;
    }          
    if (getWindowSecurity(windowSecurity.value,AppScreens.UpdatePaymentBatch) > PrivilegeType.Read) {
      formData.attachment.disabled = false;  
      return;
    }       
    if ((formData.currentUser === formData.detailsData?.assignedUserId) && (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.Read)) {
      formData.attachment.disabled = false;  
      return;
    }
    formData.attachment.disabled = true;  
  }
  function ChangeAttachment(new_image_data : string)  : void  {
    if ((!new_image_data) ||(new_image_data == ""))  {
      return;
    }
    const image_data_arr = new_image_data.split("|");

    if (image_data_arr.length == 2) {
      if (+image_data_arr[0]) {
        const paymentBatchInputs: IPaymentBatchUpdateInputs = 
          {
            update_command: PaymentBatchUpdateType.Attachment, 
            image_id: +image_data_arr[0], 
            payment_batch_id: props.paymentBatchId
          }; 
        UpdateDetails(paymentBatchInputs,DetailButtonId.Setting);
      }
    }
  }
  function attachDocument(_input : IActionButtonIdentifier | undefined) : void  {
    formData.attachment.executing  = true; 
      
    setTimeout(() => {  
      ModalWindowOpen({screenID: AppScreens.DocumentScan, urlParmData: {type : "PaymentBatch", eid: props.paymentBatchId.toString(), iid: formData.detailsData?.paymentBatchImageId ?? 0}, vueModalOnly: true}); 
      formData.attachment.executing = false;
    }, 150);
  }
  /* --------------------- */
  // Deposit Functions
  function onUpdateDeposits(isPanelOpen : boolean) : void  {
    formData.panels.deposits = isPanelOpen; 
    EnableDepositRemoveButton();
  }
  function depositRowdblclick(rowData : IRowSelection, _rowType: TableRowType, _evt: MouseEvent) {
    if (getWindowSecurity(windowSecurity.value,AppScreens.Deposit) > PrivilegeType.None) {
      if ("depositID" in rowData) {
        ModalWindowOpen({screenID: AppScreens.Deposit, urlParmData: {DepositID: (rowData as IPaymentBatchDeposits & IRowSelection).depositID.toString()}}); 
      }
    }
  }  
  function EnableDepositNewButton() : void  {
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      DepositButtons.value[DepositButtonId.New].disabled = true;
      return;
    }      
    if (getWindowSecurity(windowSecurity.value,AppScreens.DepositNew) < PrivilegeType.ReadUpdate) {
      DepositButtons.value[DepositButtonId.New].disabled = true;
      return;
    }        
    if (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.Read) {
      DepositButtons.value[DepositButtonId.New].disabled = false;
      return;
    }        
    DepositButtons.value[DepositButtonId.New].disabled = true;
  }
  function EnableDepositAddButton() : void  {
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      DepositButtons.value[DepositButtonId.Add].disabled = true;
      return;
    } 
    if (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.Read) {
      DepositButtons.value[DepositButtonId.Add].disabled = false;
      return;
    }        
    DepositButtons.value[DepositButtonId.Add].disabled = true;
  }
  function EnableDepositRemoveButton() : void  { 
    if (!formData.panels.deposits) {
      DepositButtons.value[DepositButtonId.Remove].disabled = true;
      return;
    }  
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      DepositButtons.value[DepositButtonId.Remove].disabled = true;
      return;
    }      
    if ((depositsData.value??[]).length === 0) {
      DetailButtons.value[DepositButtonId.Remove].disabled = true;
      return;
    }  
    if (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.Read) {
      DepositButtons.value[DepositButtonId.Remove].disabled = false;
      return;
    }        
    DepositButtons.value[DepositButtonId.Remove].disabled = true;
  }
  function newDeposit(_input : IActionButtonIdentifier | undefined) : void {
    DepositButtons.value[DepositButtonId.New].executing = true;  
    
    setTimeout(() => {
      DepositButtons.value[DepositButtonId.New].executing = false;
      ModalWindowOpen({screenID: AppScreens.DepositNew, urlParmData:{DepositID : "0",PaymentBatchID: props.paymentBatchId.toString()}, callBack: refreshData});
    }, 150);
  } 
  function searchAddDeposits(_input : IActionButtonIdentifier | undefined) : void {  
    DepositButtons.value[DepositButtonId.Add].executing = true;  
    resetModalConnect(true);
    formData.modal.id = ModalRequests.AddDeposit; 
    formData.searchDates.display = true;

    setTimeout(() => {
      DepositButtons.value[DepositButtonId.Add].executing = false; 
      formData.modal.display = true;
    }, 150);
  }
  function addDeposits()  : void {  
    formData.modal.executing = true;  
    const additional_deposits = getSelectedTableItems((connectData.value as any),"depositID"); 
    if (additional_deposits.length > 0) {
      const deposit_ids = additional_deposits.join(",");
      const paymentBatchIDInputs: IPaymentBatchUpdateIDInputs = {update_command: PaymentBatchUpdateIdType.Connect, payment_batch_id:props.paymentBatchId, table_ids: deposit_ids, table_type_id: PaymentBatchIdType.Deposit}; 
      resetModalConnect(false);
      modalInput.value[ModalRequests.TableUpdateResponse].title = "Deposit Add Status";
      modalInput.value[ModalRequests.TableUpdateResponse].message = "";

      secondaryModal = true;
      secondaryModalIdInput = paymentBatchIDInputs;
    }
    else {
      formData.modal.error_message = "No deposits selected.";
    }

    setTimeout(() => {  
      formData.modal.executing = false;
    },150);
  }
  function checkRemoveDeposit(_input : IActionButtonIdentifier | undefined) : void  {
    resetModalConnect(false);
    DepositButtons.value[DepositButtonId.Remove].executing = true;  

    const deposit_count = getSelectedTableCount(depositsData.value);
    if (deposit_count > 0) {
      formData.modal.id = ModalRequests.RemoveDeposit;
      modalInput.value[ModalRequests.RemoveDeposit].title = "Remove Deposit" + (deposit_count > 1 ? "s" : "");
      modalInput.value[ModalRequests.RemoveDeposit].message = "Are you sure you wish to remove the following deposit" + (deposit_count > 1 ? "s" : "") + "?<br/><br/>";
      connectData.value = getSelectedTableItems(depositsData.value);
      connectColumns.value = connectDepositColumns.value;
      formData.modal.display_connect_table = true;
    }
    else {
      formData.modal.id = ModalRequests.NoRemoveDeposit; 
    } 
    setTimeout(() => {
      DepositButtons.value[DepositButtonId.Remove].executing = false;  
      formData.modal.display = true;
    },150);
  } 
  function removeDeposit() : void {
    formData.modal.executing = true; 
    const deposit_ids = getSelectedTableItems(depositsData.value,"depositID").join(",");
    const paymentBatchIDInputs: IPaymentBatchUpdateIDInputs = {update_command: PaymentBatchUpdateIdType.Remove, payment_batch_id:props.paymentBatchId, table_ids: deposit_ids, table_type_id: PaymentBatchIdType.Deposit}; 
    
    modalInput.value[ModalRequests.TableUpdateResponse].title = "Deposit Removal Status";
    modalInput.value[ModalRequests.TableUpdateResponse].message = "";
    
    secondaryModal = true;
    secondaryModalIdInput = paymentBatchIDInputs; 
  }
  // Receipt Functions 
  function onUpdateReceipts(isPanelOpen : boolean) : void  {
    formData.panels.receipts = isPanelOpen;
    EnableReceiptRemoveButton();
  }
  function receiptRowdblclick(rowData : IRowSelection,  _rowType: TableRowType, _evt: MouseEvent) {
    if (getWindowSecurity(windowSecurity.value,AppScreens.ReceiptDetails) > PrivilegeType.None) {
      if ("receiptID" in rowData) {
        ModalWindowOpen({screenID: AppScreens.ReceiptDetails, urlParmData: {ReceiptID: (rowData as IPaymentBatchReceipts & IRowSelection).receiptID.toString()}}); 
      }
    }
  }  
  /* For now we will put a hold on this button....
  function EnableReceiptNewButton() : void  {
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      ReceiptButtons.value[ReceiptButtonId.New].disabled = true;
      return;
    }  
    if (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.None) {
      ReceiptButtons.value[ReceiptButtonId.New].disabled = false;
      return;
    }        
    ReceiptButtons.value[ReceiptButtonId.New].disabled = true;
  }
  */
  function EnableReceiptAddButton() : void { 
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      ReceiptButtons.value[ReceiptButtonId.Add].disabled = true;
      return;
    }  
    if (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.Read) {
      ReceiptButtons.value[ReceiptButtonId.Add].disabled = false;
      return;
    }         
    ReceiptButtons.value[ReceiptButtonId.Add].disabled = true;
  }
  function EnableReceiptRemoveButton()  : void {  
    if (!formData.panels.receipts ) {
      ReceiptButtons.value[ReceiptButtonId.Remove].disabled = true;
      return;
    }  
    if (formData.detailsData?.status === PaymentBatchStatus.Completed) {
      ReceiptButtons.value[ReceiptButtonId.Remove].disabled = true;
      return;
    }  
    if ((receiptsData.value??[]).length === 0) {
      ReceiptButtons.value[ReceiptButtonId.Remove].disabled = true;
      return;
    }  
    if (getWindowSecurity(windowSecurity.value,AppScreens.PaymentBatchDetail) > PrivilegeType.Read) {
      ReceiptButtons.value[ReceiptButtonId.Remove].disabled = false;
      return;
    }        
    ReceiptButtons.value[ReceiptButtonId.Remove].disabled = true;    
  }
  /* For now we will put a hold on this button....
  function newReceipt(_input : IActionButtonIdentifier | undefined) : void  {
    ReceiptButtons.value[ReceiptButtonId.New].executing = true;  
    setTimeout(() => {ReceiptButtons.value[ReceiptButtonId.New].executing = false;},150);
  } 
  */
  function searchAddReceipts(_input : IActionButtonIdentifier | undefined)  : void { 
    ReceiptButtons.value[ReceiptButtonId.Add].executing = true;  
    resetModalConnect(true);
    formData.modal.id = ModalRequests.AddReceipt; 
    formData.searchDates.display = true;

    setTimeout(() => {
      ReceiptButtons.value[ReceiptButtonId.Add].executing = false; 
      formData.modal.display = true;
    },150);
  }
  function addReceipts() : void  { 
    formData.modal.executing = true; 
    const additional_receipts = getSelectedTableItems((connectData.value as any),"receiptID"); 
    if (additional_receipts.length > 0) {
      const receipt_ids = additional_receipts.join(",");
      const paymentBatchIDInputs: IPaymentBatchUpdateIDInputs = {update_command: PaymentBatchUpdateIdType.Connect, payment_batch_id: props.paymentBatchId, table_ids: receipt_ids, table_type_id: PaymentBatchIdType.Receipt}; 
      resetModalConnect(false);
      
      modalInput.value[ModalRequests.TableUpdateResponse].title = "Receipt Add Status";
      modalInput.value[ModalRequests.TableUpdateResponse].message = "";
      
      secondaryModal = true;
      secondaryModalIdInput = paymentBatchIDInputs;
    }
    else {
      formData.modal.error_message = "No receipts selected.";
    }

    setTimeout(() => {  
      formData.modal.executing = false;
    },150);
  }
  function checkRemoveReceipt(_input : IActionButtonIdentifier | undefined) : void { 
    resetModalConnect(false);
    ReceiptButtons.value[ReceiptButtonId.Remove].executing = true;
    formData.modal.executing = true; 

    const receipt_count = getSelectedTableCount(receiptsData.value);
    if (receipt_count > 0) {
      formData.modal.id = ModalRequests.RemoveReceipt;
      modalInput.value[ModalRequests.RemoveReceipt].title = "Remove Receipt" + (receipt_count > 1 ? "s" : "");
      modalInput.value[ModalRequests.RemoveReceipt].message = "Are you sure you wish to remove the following receipt" + (receipt_count > 1 ? "s" : "") + "?<br/><br/>";
      connectData.value = getSelectedTableItems(receiptsData.value);
      connectColumns.value = connectReceiptColumns.value;
      formData.modal.display_connect_table = true;      
    }
    else {
      formData.modal.id = ModalRequests.NoRemoveReceipt; 
    }
    setTimeout(() => {
      ReceiptButtons.value[ReceiptButtonId.Remove].executing = false;  
      formData.modal.executing = false; 
      formData.modal.display = true;
    },150);
  }
  function removeReceipt() : void {
    formData.modal.executing = true; 
    const receipt_ids = getSelectedTableItems(receiptsData.value,"receiptID").join(",");
    const paymentBatchIDInputs: IPaymentBatchUpdateIDInputs = {update_command: PaymentBatchUpdateIdType.Remove, payment_batch_id:props.paymentBatchId, table_ids: receipt_ids, table_type_id: PaymentBatchIdType.Receipt}; 
    
    modalInput.value[ModalRequests.TableUpdateResponse].title = "Receipt Removal Status";
    modalInput.value[ModalRequests.TableUpdateResponse].message = "";
    
    secondaryModal = true;
    secondaryModalIdInput = paymentBatchIDInputs;
  }
  // Update functions
  async function UpdateIDs(paymentBatchInputs : IPaymentBatchUpdateIDInputs,  payment_batch_id_type: PaymentBatchIdType) : Promise<void> {
    const respSave = await paymentbatchid.UpdatePaymentBatchId(paymentBatchInputs);

    setTimeout(() => {
      formData.modal.executing = false;
    },150);
 
    if (respSave.error) {  
      formData.resultsError = {flag: true, message: (respSave.error?.error ?? "Unable to perform request")};
      popAlert(formData.resultsError.message,"Payment Batch Linkage");
      return;
    }
    
    if (respSave.success) {
      connectData.value = respSave.success.paymentBatchIDList ?? []; 
      connectColumns.value = connectUpdateColumns.value;
      formData.modal.display_connect_table = true;  
      formData.modal.id = ModalRequests.TableUpdateResponse;  
      formData.modal.display = true;
    } 
  }
  async function UpdateDetails(paymentBatchInputs : IPaymentBatchUpdateInputs, buttonId: DetailButtonId) : Promise<void> {
    const respSave = await paymentbatch.UpdatePaymentBatch(paymentBatchInputs);
    if (buttonId === DetailButtonId.Setting) { 
      setTimeout(() => {formData.setting.iconClass = DropDownButtonIconType.Gear;},150);
    }
    else {
      setTimeout(() => {DetailButtons.value[buttonId].executing = false;},150);
    }
    if (respSave.error) { 
        formData.resultsError = {flag: true, message:  (respSave.error.error ?? "Unable to perform request")};
        popAlert(formData.resultsError.message,"Unable to update Payment Batch Details");
        return;
    }
    if (respSave.success?.errorCode) {  
        formData.resultsError = {flag: (respSave.success.errorCode === 0 ? false : true), message: (respSave.success.errorMessage ?? "")};
        if (formData.resultsError) {
          popAlert(formData.resultsError.message,"Unable to update Payment Batch Details");
          return;
        }
    }  
    if (!formData.resultsError.flag) {
      refreshData(); 
    }
  }
  function ValidateFutureDate(trigger_update : boolean) : void { 
    resetErrorMessage();
    const today = new Date(getNoTzToday()); 
    const new_date = (formData.inputs.payment_batch_date ? new Date(formData.inputs.payment_batch_date) : today);
    if (new_date > today) { 
        formData.resultsWarning = {flag: true, message: "Warning: Batch Date is in the future!"};
    }
    else {
      formData.resultsWarning = {flag: false, message: ""};
    }
    if ((trigger_update) && (formData.inputs.payment_batch_date)) {
      updateDetailFields();
    }
  }  
  function updateDetailFields() : void  {
    if (formData.setting.loading) {return;}  
    if (!formData.inputsAreValid) {return;}  
    if (formData.resultsError.flag) {return}

    formData.setting.iconClass = DropDownButtonIconType.Spinner;
    const paymentBatchInputs: IPaymentBatchUpdateInputs = 
      {
        update_command: PaymentBatchUpdateType.Update,
        payment_batch_date: formData.inputs.payment_batch_date,
        description: formData.inputs.notes,
        total_amount: formData.inputs.total_input_value,
        item_count: formData.inputs.item_input_value, 
        payment_batch_id: props.paymentBatchId
      }; 
    UpdateDetails(paymentBatchInputs,DetailButtonId.Setting);
  } 
  function resetErrorMessage() : void {
    formData.resultsError = {flag: false, message: ""}; 
  }
  // Setting Functions
  function displayAudit() : void  {
    formData.setting.iconClass = DropDownButtonIconType.Spinner;
      
    setTimeout(() => {  
      ModalWindowOpen({screenID: AppScreens.Logging, urlParmData: {ScreenName: "PaymentBatchDetail.htm", LogType: "s", StatementId: props.paymentBatchId.toString()}, title: "Payment Batch Audit"}); 
      formData.setting.iconClass = DropDownButtonIconType.Gear;
    }, 150);
  }
  function ModalHiddenResponse() {
    // Check to see if a secondary modal window should be displayed
    if (secondaryModal) {
      secondaryModal = false;
      if (secondaryModalIdInput) {
        UpdateIDs(secondaryModalIdInput, secondaryModalIdInput.table_type_id); 
      }
    }
  }
  
</script>

<style scoped> 
    .viewDisplay {
        display: block;
    }
    .viewHide {
        display: none;
    }
    .cardActions {
        font-size: .85rem;
        font-weight: 500;
        color: #204D89;
    }
    .billing_header {
      color: #204D89;
      background-color: #f1f1f1;
    }
    .billing_data_left {
      color: black;
      background-color: white;
      text-align: left;
    }    
    .billing_data_center {
      color: black;
      background-color: white;
      text-align: center;
    }
    .billing_data_right {
      color: black;
      background-color: white;
      text-align: right;
    }
    .billing_cell {
      border: 1px solid #6A8CCB;
      FONT-SIZE: 8pt;
      font-family: Arial, sans-serif, Helvetica;
      padding: 5px 5px 5px 5px;
      cursor: default;
      vertical-align: middle;
    }
    .reporting_cell_left {
      border: none;
      FONT-SIZE: 8pt;
      font-family: Arial, sans-serif, Helvetica;
      padding: 5px 5px 5px 5px;
      cursor: default;
      vertical-align: middle;
      text-align: left;
    }
    @media print {
        .hideDuringPrint { display:none; }
    }
</style>
<template>  
  <div class="row hideDuringPrint">
    <div class="col-11">
      <div class="container-fluid g-0 fw-bold" style="color: #204D89; font-size: 1rem;"> 
        Payment Batch
      </div>   
    </div>  
    <div class="col-1 text-end">
      <DropDownButton :display-style="ButtonDisplayStyle.Link" :buttonIcon="formData.setting.iconClass" >
        <DropDownButtonItem style="font-size: .75rem;" :data="PageActions.Audit" @click="displayAudit">Audit</DropDownButtonItem>
        <DropDownButtonItem style="font-size: .75rem;" :data="PageActions.Refresh" @click="refreshData">Refresh</DropDownButtonItem> 
      </DropDownButton>
    </div>
  </div>  
  <div v-show="formData.reporting.display" class="row">
    <div class="row">
      <div class="col-3"></div>
      <div class="col-6"> 
        <table border="0" aria-hidden="true" style="table-layout: fixed; border-collapse: collapse; width:340px;">
          <caption style="caption-side:top; text-align: center;">Payment Batch Report</caption>
          <colgroup>
            <col style="width: 85px" />
            <col style="width: 85px" />
            <col style="width: 85px" />
            <col style="width: 85px" />
          </colgroup>
          <tbody>
            <tr> 
              <td class="reporting_cell_left">Batch #:</td>
              <td class="reporting_cell_left">{{formData.detailsData?.paymentBatchId}}</td>
              <td class="reporting_cell_left">Batch Date</td>
              <td class="reporting_cell_left">{{toDisplayDateString(formData.inputs.payment_batch_date,DateDisplayFormat.NumericDate)}}</td>
            </tr>
            <tr> 
              <td class="reporting_cell_left">Item Count:</td>
              <td class="reporting_cell_left">{{formData.inputs.item_input_value}}</td>
              <td class="reporting_cell_left">Batch Amount</td>
              <td class="reporting_cell_left">{{prettyCurrency(formData.inputs.total_input_value)}}</td>
            </tr>
          </tbody>
        </table>
      </div> 
      <div class="col-3"></div>
    </div>
    <div class="row">
      <div class="col-12">
        <p style="font-size: .75rem;">
        <ChoiceTable 
              ref="reportTable"
              :columns="reportColumns" 
              :data="reportData" 
              :footerVals="formData.reportingFooter"
              :show-filters="false" 
              :show-footer="true" 
              :allowSorting="true"
              :key-value-data-member="'ID'">
          </ChoiceTable>
        </p>
      </div>
    </div>    
    <div class="row hideDuringPrint">
      <div class="col-12">
        <div style="font-size: 1.25rem; text-align: right;"> 
          <ActionButton
            :executing="formData.reporting.printing"   
            :toolTip = "'Print Payment Batch Report'"
            :base-class="billingBaseClass" 
            :disabled=false   
            :clickEvent="reportPrint"  
            :width="modalButtonWidth"
            :overRideStyle="ActionButtonStyle.Print" 
            :endingPadding="1"/> 
          <ActionButton
            :executing="formData.reporting.exporting"   
            :toolTip = "'Print Payment Batch Report'"
            :base-class="billingBaseClass" 
            :disabled=false   
            :clickEvent="reportExport" 
            :width="modalButtonWidth"
            :overRideStyle="ActionButtonStyle.Export"
            :endingPadding="1" /> 
          <ActionButton
            :executing="formData.reporting.executing"  
            :baseText = "'Details'"
            :toolTip = "'Return to Payment Batch Details'"
            :base-class="billingBaseClass" 
            :disabled=false   
            :clickEvent="reportDetails" 
            :width="modalButtonWidth"
            :overRideStyle="ActionButtonStyle.Previous"/> 
        </div>
      </div>
    </div>
  </div>
  <div v-show="!formData.reporting.display" class="row">
    <ActionFoldingPanel
      panelTitle="Details" 
      actionTitle="Detail Actions" 
      :actionList="DetailButtons"   
      @update:actionPanel="onUpdateDetails"
    > 
      <template #body>
        <p>
        <table border="0" aria-hidden="true" style="border: 1px solid blue; table-layout: fixed; border-collapse: collapse; width: 740px;">
          <colgroup>
            <col style="width: 90px" />
            <col style="width: 150px" />
            <col style="width: 90px" />
            <col style="width: 150px" />
            <col style="width: 90px" />
            <col style="width: 150px" />
          </colgroup>
          <tr>
            <td class="billing_header billing_cell">Batch Date</td>
            <td class="billing_cell">
              <DatePickerNoTZ
                  v-model:value="formData.inputs.payment_batch_date" 
                  :clearable="false" 
                  :required=true
                  :errorDisplay=false 
                  :placeholder="'Payment Date'"
                  :cssFramework="'vanilla'"
                  @update:value="()=>ValidateFutureDate(true)" 
                  @validationState="(state, msg) => validateSection?.sinkValidation('Batch Date', state, msg)" 
              /> 
            </td>            
            <td class="billing_header billing_cell">Total</td>
            <td class="billing_cell">
              <CurrencyInput 
                  v-model:numberValue="formData.inputs.total_input_value" 
                  :maxLength=12 
                  :startingRange=0.00
                  :endingRange=1000000.00
                  :positive=true  
                  placeholder="Total amount" 
                  :cssFramework = "'vanilla'" 
                  @update:text-value="() => resetErrorMessage()" 
                  @change:numberValue="() => updateDetailFields()"
                  @validationState="(state, msg) => validateSection?.sinkValidation('Batch Total', state, msg)" 
              />
            </td>
            <td class="billing_header billing_cell">Items</td>
            <td class="billing_cell">
              <IntegerInput 
                  v-model:numberValue="formData.inputs.item_input_value" 
                  :maxLength=6 
                  :startingRange=0
                  :endingRange=99999
                  :positive=true
                  placeholder="Total items"
                  LeftAddon="fa-solid fa-hashtag"
                  :cssFramework = "'vanilla'" 
                  @update:text-value="() => resetErrorMessage()" 
                  @change:numberValue="()=>updateDetailFields()" 
                  @validationState="(state, msg) => validateSection?.sinkValidation('Batch Items', state, msg)" 
              /> 
            </td>
          </tr>
          <tr>
            <td class="billing_header billing_cell">Status</td>
            <td class="billing_data_left billing_cell">{{formData.detailsData?.statusDescription}}</td>
            <td class="billing_header billing_cell">Total Posted</td>
            <td class="billing_data_right billing_cell">{{ToAccountingMoneyStr(formData.detailsData?.totalPosted ?? 0)}}</td>
            <td class="billing_header billing_cell">Items Posted</td>
            <td class="billing_data_right billing_cell">{{ToPrettyNumber(formData.detailsData?.itemsPosted ?? 0)}}</td>         
          </tr>
          <tr>
            <td class="billing_header billing_cell">ID</td>
            <td class="billing_data_left billing_cell">{{formData.detailsData?.paymentBatchId}}</td>       
            <td class="billing_header billing_cell">Total Applied</td>
            <td class="billing_data_right billing_cell">{{ToAccountingMoneyStr(formData.detailsData?.totalApplied ?? 0)}}</td>
            <td class="billing_header billing_cell">Items Applied</td>
            <td class="billing_data_right billing_cell">{{ToPrettyNumber(formData.detailsData?.itemsApplied ?? 0)}}</td>
          </tr>
          <tr>
            <td class="billing_header billing_cell">Assigned To</td>
            <td class="billing_data_left billing_cell">{{formData.detailsData?.assignedUserId}}</td>
            <td class="billing_header billing_cell">Completed By</td>
            <td class="billing_data_left billing_cell">{{formData.detailsData?.completedBy}}</td>   
            <td class="billing_header billing_cell">Created By</td>
            <td class="billing_data_left billing_cell">{{formData.detailsData?.createdBy}}</td>          
          </tr>
          <tr>
            <td class="billing_header billing_cell">Notes</td>
            <td colspan="5" class="billing_data_left billing_cell">
              <TextInput 
                :rows=2
                v-model:textValue="formData.inputs.notes" 
                :cssFramework="'vanilla'"  
                placeholder="Payment Batch notes" 
                @update:text-value="() => resetErrorMessage()" 
                @change:text-value="() => updateDetailFields()" 
              />
            </td>
          </tr>
          <tr>
            <td colspan="6" style="border: none;"> 
              <span style="font-size: 1.25rem;"> 
                <ActionButton
                  :executing="formData.attachment.executing"  
                  :base-text="formData.attachment.text"
                  :base-class="textBaseClass"
                  :disabled="formData.attachment.disabled"    
                  :clickEvent="attachDocument" 
                  :width="500"
                  :toolTip="'Attach document to Payment Batch'" 
                  :spinClass="spinnerClassSmall"
                  :spin-text="'Attaching payment batch file'"
                  :overRideStyle="ActionButtonStyle.Attach">
                </ActionButton>      
              </span>
            </td>
          </tr> 
        </table>
        </p>
        <Validator ref="validateSection" @is-valid="state => formData.inputsAreValid = state">
          <template></template>
        </Validator>
        <div v-if="formData.resultsError.flag"  class="container-fluid text-danger">
          {{formData.resultsError.message}}
        </div>  
        <div v-if="formData.resultsWarning.flag"  class="container-fluid text-warning">
          {{formData.resultsWarning.message}}
        </div>  
      </template> 
    </ActionFoldingPanel>  
    <ActionFoldingPanel
      panelTitle="Deposits" 
      actionTitle="Deposit Actions" 
      :actionList="DepositButtons"  
      @update:actionPanel="onUpdateDeposits"
    > 
      <template #body>
        <p style="font-size: .75rem;">
          <ChoiceTable 
              ref="depositTable"
              :columns="depositColumns" 
              :data="depositsData" 
              :show-filters="false" 
              :allowSorting="true"
              :checkBoxScale="1.2"
              @rowdblclick="depositRowdblclick"
              :key-value-data-member="'depositID'">
          </ChoiceTable>
        </p>
      </template> 
    </ActionFoldingPanel>  
    <ActionFoldingPanel
      panelTitle="Receipts" 
      actionTitle="Receipts Actions" 
      :actionList="ReceiptButtons" 
      @update:actionPanel="onUpdateReceipts"
    > 
      <template #body>
        <p style="font-size: .75rem;"> 
          <ChoiceTable 
              ref="receiptTable"
              :columns="receiptColumns" 
              :data="receiptsData" 
              :show-filters="false" 
              :allowSorting="true"
              :checkBoxScale="1.2"
              @rowdblclick="receiptRowdblclick"
              :key-value-data-member="'receiptID'">
          </ChoiceTable> 
        </p>
      </template> 
    </ActionFoldingPanel> 
  </div>  
  <ModalDialog v-model:show="formData.modal.display" @hidden="ModalHiddenResponse"  :closeOnClickOutside=false>
    <template #title>{{modalInput[formData.modal.id].title}}</template>
    <div v-show="modalInput[formData.modal.id].message !== ''" class="row">
        <div class="col">
          <span v-html="modalInput[formData.modal.id].message"></span>
        </div>
    </div> 
    <div v-show="formData.searchDates.display" class="row">
      <div class="col-2 text-end" style="font-size: 1rem;">  
        Search Range:
      </div>
      <div class="col-2" style="font-size: .75rem;">  
        <DatePickerNoTZ
          v-model:value="formData.searchDates.start_date" 
          :clearable="false" 
          :required=true
          :errorDisplay=false 
          :placeholder="'Start Date'"
          :cssFramework="'vanilla'"
        /> 
      </div>
      <div class="col-2" style="font-size: .75rem;"> 
        <DatePickerNoTZ
          v-model:value="formData.searchDates.end_date" 
          :clearable="false" 
          :required=true
          :errorDisplay=false  
          :placeholder="'End Date'"
          :cssFramework="'vanilla'"
        /> 
      </div>
      <div class="col-6"></div>
      <br/>
      <br/>
    </div>
    <div v-show="formData.modal.display_connect_table" class="row">
      <div class="col-8" style="font-size: .75rem; height: 300px; overflow: auto;"> 
          <ChoiceTable 
              ref="connectTable"
              :columns="connectColumns" 
              :data="connectData" 
              :show-filters="false" 
              :allowSorting="false"
              :key-value-data-member="'tableID'">
          </ChoiceTable> 
      </div>
      <div class="col-4"></div>
    </div> 
    <template #footer>   
      <div v-show="formData.modal.error_message" class="text-danger text-start" style="font-size: 1rem;">  
        {{formData.modal.error_message}}
        <br/>
      </div>  
      <div v-show="formData.searchDates.display" style="font-size: 1.25rem;"> 
        <ActionButton
          :executing="formData.searchDates.executing"  
          :base-class="billingBaseClass" 
          :disabled=false   
          :clickEvent="executeSearch" 
          :width="modalButtonWidth"
          :overRideStyle="ActionButtonStyle.Search" 
          :endingPadding="1"/>
      </div>
      <div v-show="modalInput[formData.modal.id].completeText !== ''" style="font-size: 1.25rem;">   
        <ActionButton
          :executing="formData.modal.executing"  
          :base-class="billingBaseClass"
          :base-text="modalInput[formData.modal.id].completeText"
          :disabled=false   
          :clickEvent="executeModal" 
          :width="modalButtonWidth"
          :toolTip="modalInput[formData.modal.id].completeTootlTip"  
          :overRideStyle="ActionButtonStyle.Complete" 
          :endingPadding="1" />
      </div> 
      <div v-show="modalInput[formData.modal.id].closeToolTip !== ''" style="font-size: 1.25rem;">  
        <ActionButton
          :executing="formData.modal.closing"  
          :base-class="billingBaseClass"
          :disabled=false  
          :clickEvent="cancelModal" 
          :width="modalButtonWidth"
          :toolTip="modalInput[formData.modal.id].closeToolTip"  
          :overRideStyle="ActionButtonStyle.Close" />
      </div>  
    </template>
  </ModalDialog>
</template>

